import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import toast from '../components/toast'

var show = (confirm) => {
    const MySwal = withReactContent(Swal)
    MySwal.fire({
        allowOutsideClick: true,
        title: 'آیا از لغو سرویس اطمینان دارید',
        icon: 'warning',
        confirmButtonText: "لغو شود",
        denyButtonText: "فعلا نه",
        showDenyButton: true

    }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
            confirm()
        }

    })
    return MySwal;
}

export default {
    show: show,
}

